// src/components/PricingSection.js
import React, { useState } from "react";
import HomePricingCard from "./homePricingCards"
import { Check } from "lucide-react";
import { PlanType } from "../enums/prices";
const PricingSection = ({ currentPlan } = {}) => {
  const [billingPeriod, setBillingPeriod] = useState("monthly");

  const pricingCards = [
    // {
    // title: "Free Trial Plan",monthlyPrice : "Free",yearlyPrice : "Free",period: "",description: "",features: [
    //  "100 on market leads",
    //  "Single family properties",
    //  "Mortgage information",
    //  "Owner information", 
    //  "Agent information"],  
    //isFeatured: false,
    //buttonText: "Get Started",
    //plantype: PlanType.FREE,

    //},
    {
      title: "Openning Plan",
      price: "$497",
      monthlyPrice: "$497",
      yearlyPrice: "$497",
      period: "/Lifetime",
      description: "",
      features: ["20,000 Credit", "All types of properties", "Keyword filters", "Owner information", "Agent information"],
      isFeatured: true,
      buttonText: "Get Started",
      plantype: PlanType.ONETIMEDEAL,
    },
  ];

  // Logic to determine which cards to show
  const getDisplayedCards = () => {
    if (currentPlan) {
      if (currentPlan === PlanType.ENTREPRISE) {
        return []; // No cards for Premium Plan, entire section removed
      } else if (currentPlan === PlanType.ADVACED) {
        return pricingCards.filter(card => card.title === "Entreprise Plan");
      } else if (currentPlan === PlanType.BASIC) {
        return pricingCards.filter(card => card.title === "Advanced Plan" || card.title === "Entreprise Plan");
      } else if (currentPlan === PlanType.FREE) {
        return pricingCards.filter(card => card.title === "Basic Plan" || card.title === "Advanced Plan" || card.title === "Premium Plan");
      }
    }
    return pricingCards; // Default to all cards if no currentPlan (e.g., homepage)
  };

  const displayedCards = getDisplayedCards();

  const toggleBillingPeriod = () => {
    setBillingPeriod(prev => (prev === "Monthly" ? "Yearly" : "Monthly"));
  };
  // Render pricing section only if there are cards to display
  if (displayedCards.length === 0) {
    return null; // No pricing section for Premium Plan or unrecognized plans
  }

  return (
    <section id="pricing" className="py-12 pb-0 bg-transparent">
      <div className="min-h-screen bg-gray-100 flex flex-col items-center p-4">
        <div className="relative  w-full max-w-[95vw] bg-white rounded-lg shadow-lg p-4">
          <button
            onClick={toggleBillingPeriod}
            className="absolute top-8 right-8 bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 hover:scale-105 transition-transform"
          >
            {billingPeriod === "Monthly" ? "Monthly" : "Yearly"}
          </button>
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-gray-900 mb-4 leading-tight">
              Choose The Plan That Fits<br />
              Your Needs :
            </h1>

          </div>
          <div
            className={`grid gap-6 max-w-6xl mx-auto mb-12 ${displayedCards.length === 1 ? "grid-cols-1 place-items-center" : "md:grid-cols-3"
              }`}
          >
            {displayedCards.map((card, index) => (
              <HomePricingCard
                key={index}
                title={card.title}
                price={billingPeriod === "Monthly" ? card.monthlyPrice : card.yearlyPrice}
                period={
                  card.title === "Free Trial Plan"
                    ? "/month"      // always fixed for Free Trial
                    : billingPeriod === "Monthly"
                      ? "/month"
                      : "/year"
                }
                description={card.description}
                features={card.features}
                isFeatured={card.isFeatured}
                buttonText={card.buttonText}

              />
            ))}
          </div>
          <div className="text-center mt-8">
            <h3 className="text-2xl font-semibold text-gray-900 mb-4">All Plans Include</h3>
            <ul className="text-gray-600 text-base space-y-2 text-center mx-auto max-w-md">
              <li className="flex items-center justify-center">
                <Check className="w-5 h-5 text-blue-600 mr-2" />
                Access to comprehensive U.S. real estate datasets
              </li>
              <li className="flex items-center justify-center">
                <Check className="w-5 h-5 text-blue-600 mr-2" />
                Customizable data filters and reports
              </li>
              <li className="flex items-center justify-center">
                <Check className="w-5 h-5 text-blue-600 mr-2" />
                Intuitive platform for data analysis
              </li>
              <li className="flex items-center justify-center">
                <Check className="w-5 h-5 text-blue-600 mr-2" />
                No advanced data skills required
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PricingSection;